<template>
  <label
    :class="[
      ns.b('button'),
      ns.bm('button', size),
      ns.is('disabled', isDisabled),
      ns.is('checked', isChecked),
      ns.is('focus', focus),
    ]"
    role="checkbox"
    :aria-checked="isChecked"
    :aria-disabled="isDisabled"
  >
    <input
      v-model="model"
      :class="ns.be('button', 'original')"
      type="checkbox"
      v-bind="attrs"
      :disabled="isDisabled"
      :value="label"
      @change="handleChange"
      @focus="focus = true"
      @blur="focus = false"
    />

    <span
      v-if="$slots.default || label"
      :class="ns.be('button', 'inner')"
    >
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'
import { useNamespace } from '@sgui-plus/hooks'
import { useCheckbox, useCheckboxProps } from './useCheckbox'

export default defineComponent({
  name: 'SgCheckboxButton',
  props: useCheckboxProps,
  emits: [UPDATE_MODEL_EVENT, 'on-change'],
  setup(props,{ attrs }) {
    const { focus, isChecked, isDisabled, size, model, handleChange } = useCheckbox(props)
    const ns = useNamespace('checkbox')

    return {
      attrs,
      focus,
      isChecked,
      isDisabled,
      model,
      handleChange,
      size,
      ns,
    }
  },
})
</script>
